import { IFilters } from '@chess-class/sandbox';
import { paginationBaseFilters } from '@chess-class/sandbox/consts';

export const appSettingsFilters: IFilters = {
  ...paginationBaseFilters,
  sortBy: {},
  sortDirection: {},
};
